import {LinkOnComponent} from 'app/components/links/link';
import React from 'react';
import {generateBasicCompetitionLink} from 'app/helpers/actionsHelpers';
import CompetitionCategory from 'app/models/competition/CompetitionCategory';

const isTestmatchCompetition = competition => {
  if (!competition.category) {
    return false;
  }
  const competitionCategory = new CompetitionCategory(competition.category);
  return competitionCategory.isTestmatch();
};

const LinkToCompetition = ({competition, competitionType, subpage, children, ...props}) => {
  if (isTestmatchCompetition(competition)) {
    return children;
  }
  const basicUrl = generateBasicCompetitionLink(competition, competitionType);
  const rel = competition.active ? 'follow' : 'nofollow';
  const link = subpage ? `${basicUrl}/${subpage}` : basicUrl;

  return (
    <LinkOnComponent to={link} rel={rel} {...props}>
      {children}
    </LinkOnComponent>
  );
};

export {LinkToCompetition};
